export const tabs = [
  { name: 'Add Product', value: 'AddedProduct', path: '' },
  //   { name: 'Create Auction', value: 'CreateAuction', path: 'create-auction' },
  { name: 'User Products', value: 'user-products', path: 'user-products' },
  { name: 'User Auctions', value: 'user-auctions', path: 'user-auctions' },
]
